<template>
  <div class="upcoming-outside-manners">
    <div v-if="dates.length">
      <h2>Upcoming Classes</h2>
      <div class="upcoming-classes-container" v-for="date in dates" :key="date.days">
        <div class="upcoming-class">
          <div><b>{{date.days}}</b></div>
          <div>Starting: <b>{{date.starting}}</b></div>
          <div>Ending: {{date.ending}}</div>
          <div>Location: {{date.location}}</div>
          <div class="price">{{date.price}}</div>
          <div>Limited to {{date.limit}} spots</div>
          <div v-for="note in date.notes" :key="note" class="notes">{{note}}</div>
        </div>
        <va-button @click="openModal(date)" class="request-button">Request to join</va-button>
      </div>
    </div>
    <va-modal v-model="showModal" title="Request to Join Outside Manners Class" :message="modalMessage"
      position="top" size="large" hide-default-actions>
      <group-class-form :groupClass="requestedGroupClass" @sent-request="closeModal" />
      <div class="cancel-button" style="display: flex; justify-content: center;">
        <va-button flat color="gray" @click="closeModal">
          Cancel
        </va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import GroupClassForm from '../forms/GroupClassForm'

export default {
  name: 'outside-manners-card',
  components: {
    GroupClassForm,
  },
  data () {
    return {
      dates: [
        // {
        //   days: 'Wednesdays at 5:30pm',
        //   starting: 'September 21, 2022',
        //   ending: 'October 12, 2022',
        //   location: 'Sunset Maple Park, Lafayette, CO',
        //   price: '$140',
        //   limit: 6,
        //   type: 'Outside Manners',
        //   notes: [
        //     'Prerequisite: basic manners group class or private lessons with a force free, positive reinforcement trainer.',
        //     'To be prepared for class, please bring your dog on a flat leash (non retractable) and harness (no-pull recommended), a water bowl with water, and lots of high value treats. Your dog must be up to date on vaccinations.',
        //   ],
        // },
        // {
        //   days: 'Sundays at 12:00pm',
        //   starting: 'May 15, 2022',
        //   ending: 'June 5, 2022',
        //   location: 'TBD in Boulder, CO',
        //   price: '$140',
        //   limit: 6,
        //   type: 'Outside Manners',
        //   notes: [
        //     'Prerequisite: basic manners group class or private lessons with a force free, positive reinforcement trainer.',
        //     'To be prepared for class, please bring your dog on a six foot leash (non retractable) and harness (no-pull recommended), a water bowl with water, and lots of high value treats. Your dog must be up to date on vaccinations.',
        //   ],
        // },
      ],
      showModal: false,
      modalMessage: 'Request to join class',
      sendButtonText: 'Send',
      requestedGroupClass: {},
    }
  },
  methods: {
    // signUpGroupClass () {
    //   const link = 'https://buy.stripe.com/dR6g2XfmS2zl1qM5kk'

    //   window.open(link, '_blank')
    // },
    openModal (groupClass) {
      this.modalMessage = `Request to join ${groupClass.days} ${groupClass.type} class`
      this.requestedGroupClass = groupClass
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
  },
}
</script>

<style scoped lang="scss">
.upcoming-outside-manners {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;

  .upcoming-classes-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .upcoming-class {
      display: flex;
      flex-direction: column;
      border-left: 2px solid $gray;
      margin: 0.5rem;
      padding-left: 0.5rem;

      .price {
        font-weight: 600;
      }

      .notes {
        font-style: italic;
        margin-top: 1rem;
      }
    }

    .request-button {
      height: 3rem;
      width: auto;
    }
  }
}
</style>
